import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/first',
    name: 'index',
    meta: {
      title: '首页',
      requireAuth: true,
    },
    component: () => import('@/views/index.vue'),
    children: [
      {
        path: '/paramsSet',
        name: 'paramsSet',
        meta: {
          title: '参数设置',
          requireAuth: true,
        },
        component: () => import('@/views/my/paramsSet.vue'),
      },
      {
        path: '/zhicheng',
        name: 'zhicheng',
        meta: {
          title: '职称代码',
          requireAuth: true,
        },
        component: () => import('@/views/my/zhicheng.vue'),
      },
      {
        path: '/notification',
        name: 'notification',
        meta: {
          title: '通知公告',
          requireAuth: true,
        },
        component: () => import('@/views/my/notification.vue'),
      },
      {
        path: '/teacherOtherworking',
        name: 'teacherOtherworking',
        meta: {
          title: '教师其他工作量',
          requireAuth: true,
        },
        component: () => import('@/views/my/teacherOtherworking.vue'),
      },
      {
        path: '/summary',
        name: 'summary',
        meta: {
          title: '教师工作量绩效',
          requireAuth: true,
        },
        component: () => import('@/views/my/summary.vue'),
      },
      {
        path: '/total',
        name: 'total',
        meta: {
          title: '教师考勤汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/total.vue'),
      },
      {
        path: '/stutotal',
        name: 'stutotal',
        meta: {
          title: '学生考勤汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/stutotal.vue'),
      },
      {
        path: '/teachingEquipment',
        name: 'teachingEquipment',
        meta: {
          title: '教学设备情况汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/teachingEquipment.vue'),
      },
      {
        path: '/journalSummary',
        name: 'journalSummary',
        meta: {
          title: '教学日志汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/journalSummary.vue'),
      },
      {
        path: '/tkbkSummary',
        name: 'tkbkSummary',
        meta: {
          title: '停课补课统计',
          requireAuth: true,
        },
        component: () => import('@/views/my/tkbkSummary.vue'),
      },
      {
        path: '/teachingTask',
        name: 'teachingTask',
        meta: {
          title: '教学任务',
          requireAuth: true,
        },
        component: () => import('@/views/my/teachingTask.vue'),
      }
    ]
  },
  {
    path: '/two',
    name: 'tow',
    meta: {
      title: '首页',
      requireAuth: true,
    },
    component: () => import('@/views/two.vue'),
    children:[
      {
        path: '/teacherOtherworking',
        name: 'teacherOtherworking',
        meta: {
          title: '教师其他工作量',
          requireAuth: true,
        },
        component: () => import('@/views/my/teacherOtherworking.vue'),
      },
    ]
  },
  {
    path: '/three',
    name: 'three',
    meta: {
      title: '首页',
      requireAuth: true,
    },
    component: () => import('@/views/three.vue'),
    children:[
      {
        path: '/total',
        name: 'total',
        meta: {
          title: '教师考勤汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/total.vue'),
      },
      {
        path: '/stutotal',
        name: 'stutotal',
        meta: {
          title: '学生考勤汇总',
          requireAuth: true,
        },
        component: () => import('@/views/my/stutotal.vue'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录页',
      requireAuth: false
    },
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/',
    name: 'login',
    meta: {
      title: '登录页',
      requireAuth: false
    },
    component: () => import('@/views/login.vue'),
  }
]

const router = new Router({
  routes,
  mode: "history",
  base: "/",
  scrollBehavior(to, from, savePotion) {
    if (savePotion) {
      return savePotion
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  console.log(`to.fullPath`, to.fullPath)
  console.log(store.getters.getUserData.yhm)
   if (!store.getters.getUserData.yhm && to.path !== '/login') {
      next('/login')
    } else if(to.path == '/' && store.getters.getUserData.yhm) {
      console.log("1111111");
      next('/first')
    }  else{
      console.log("222222");
      next()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js